;(function(){
    'use strict';

    window.MAPPING_REALTIME_FEED_BASTIAN = {
        'link': {
            'sel': 'a',
            'ctx': '.bastian',
            'spt': 'Links',
            'reg': 'Feed Bastian'
        }
    };
})();
